// @flow
/**
 * Splits a custom widget's live usage into pages a redeploy will update and
 * pages that stay on a pinned version. Draft pins count as updating, because
 * deploys resolve them to the published version.
 */
type UsagePage = {
  pageId: string,
  path: string,
  title: string,
  pageVersionId: ?string,
  followingLatest: number,
  pinnedToDraft: number,
  pinned: number,
  pinnedVersions: Array<string>,
  presets: Array<string>
};

export const summarizeUsage = (pages: ?Array<UsagePage>) => {
  const list = pages || [];
  const updating = list.filter(p => p.followingLatest + p.pinnedToDraft > 0);
  const pinnedOnly = list.filter(p => p.followingLatest + p.pinnedToDraft === 0);
  const pinnedPresets = Array.from(new Set(
    pinnedOnly.reduce((all, p) => all.concat(p.presets || []), [])
  )).sort();
  return {
    total: list.length,
    updating,
    pinnedOnly,
    pinnedPresets,
    // Only pages with a known published version id can be redeployed.
    redeployable: updating.filter(p => p.pageVersionId)
  };
};

export const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;
